// ══════════════════════════════════════════════════════════════════════════════════════════════
//  B-352 · COMPARTIR UNA CONVERSACIÓN, DESDE CUALQUIER SITIO (26-sep-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El menú de acciones de una conversación (pages/Conversaciones) solo lanza el evento 'biango-compartir-conversacion' con
//  { id, nombre }: la ventana vive aquí, montada una vez en la app (App.jsx), igual que el Busca. Así la pantalla de
//  WhatsApp no carga nada más ni cambia sus estados.
import { useEffect, useState } from 'react'
import CompartirConversacion from './CompartirConversacion'

export const EVENTO_COMPARTIR_CONVERSACION = 'biango-compartir-conversacion'

export default function CompartirConversacionGlobal() {
  const [conv, setConv] = useState(null)
  useEffect(() => {
    const abrir = (e) => {
      const d = e && e.detail
      const id = Number(d && d.id)
      if (Number.isInteger(id) && id > 0) setConv({ id, nombre: String((d && d.nombre) || '') })
    }
    window.addEventListener(EVENTO_COMPARTIR_CONVERSACION, abrir)
    return () => window.removeEventListener(EVENTO_COMPARTIR_CONVERSACION, abrir)
  }, [])
  if (!conv) return null
  return <CompartirConversacion conv={conv} onCerrar={() => setConv(null)} />
}
